



















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { SendPacket } from '../../networking/SendPacket';
import { PacketType } from '../../models/Packet';
import Timeline from '../../models/Timeline';
import ProjectServer from '@/models/ProjectServer';
import TimelineAccess from '../../models/TimelineAccess';
import Project from '../../models/Project';
import TimelineAccessUserData from '../../models/TimelineAccessUserData';
import store from '@/store/store'
import BestFitText from "@/components/BestFitText.vue";
import Folder from '@/models/Folder';
import FolderCommands from '@/networking/Folder';

class UserProjectAccess
{
    userid=""
    username=""
    display_name : string | null = null
    email=""
    userGroupID=-1
    
    public get uiName()
    {
        return this.display_name || this.username;
    }
}

@Component({
    components: 
    {
        BestFitText
    },
    computed: {
        ...mapGetters([
            'checkFolderAdmin'
        ])
    }
})

export default class TimelinePermissions extends Vue {
    @Prop(Folder) readonly folder! : Folder;

    get project() : Project
    {
        return this.$store.state.project.project as Project;
    }
    
    accessListCounter = 0;
    get accessList()
    {
        if (this.accessListCounter === 0 && this.accessListCounter !== 0) alert('???');
        let tg = this as TimelinePermissions;
        return tg.folder.accessList;
    }

    loadingAccessList = false;
    recomputeRequest = -1;

    user_filter= "";
    tl_user_filter= "";
    usergroups = [
        { id: 1, name: "View Only" },
        { id: 2, name: "Share & View" },
        { id: 3, name: "Edit & Share" },
        { id: 4, name: "Timeline Admin" },
    ]

    project_users : UserProjectAccess[] = []
    loading_project_users = false
    get loading()
    {
        return this.loading_project_users || this.loadingAccessList;
    }

    get filteredProjectList()
    {
        let res : TimelineAccess[] = [];

        let trimmed = this.user_filter.trim().toLowerCase();
        let accessList = new Map<string, TimelineAccess>();
        for(const access of (this as any).accessList as TimelineAccess[])
        {
            accessList.set(access.User.userid.toLowerCase(), TimelineAccess.fromJsonObject(access));
        }

        for(let user of this.project_users)
        {
            let access = accessList.get(user.userid.toLowerCase());
            if ((access == null || access.Permission == 0) && (trimmed.length == 0 || user.uiName.toLowerCase().includes(trimmed)))
            {
                let tacc = new TimelineAccess;
                tacc.Permission = 0;
                this.$set(tacc, 'User', new TimelineAccessUserData);
                tacc.User.userid = user.userid;
                tacc.User.username = user.username;
                tacc.User.display_name = user.display_name;
                tacc.User.email = user.email;
                tacc.User.currentUser = this.user.userid == user.userid;
                (tacc.User as any).isAdmin = user.userGroupID == 1;
                res.push(tacc);
            }
        }
        /*
        for(let kv of (this as any).accessList as Map<string, TimelineAccess>)
        {
            let access = kv[1];
            if (access.Permission == 0 && (trimmed.length == 0 || access.User.username.toLowerCase().includes(trimmed)))
            {
                res.push(access);
            }
        }
        */

        res.sort((a, b)=>
        {
            var textA = (a.User.display_name || a.User.username).toLowerCase().trim();
            var textB = (b.User.display_name || b.User.username).toLowerCase().trim();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        return res;
    }

    get filteredAccessList()
    {
        let res : TimelineAccess[] = [];

        let trimmed = this.tl_user_filter.trim().toLowerCase();
        for(let access of (this as any).accessList as TimelineAccess[])
        {
            if (access.Permission > 0 && (trimmed.length == 0 || access.User.uiName.toLowerCase().includes(trimmed)))
            {
                res.push(TimelineAccess.fromJsonObject(access));
            }
        }

        res.sort((a, b)=>
        {
            console.log({a, b});
            var textA = (a.User.display_name || a.User.username).toLowerCase().trim();
            var textB = (b.User.display_name || b.User.username).toLowerCase().trim();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        return res;
    }

    recomputeListener = -1;
    async mounted()
    {
        this.recomputeListener = ProjectServer.instance.registerCallback(PacketType.FolderUpdateAccess, ()=>{
            this.accessListCounter++;
        });
        await this.refresh();
    }

    beforeDestroy()
    {
        if (ProjectServer.instance.removeCallback(PacketType.TimelineUpdateAccess, this.recomputeListener))
        {
            this.recomputeListener = -1;
        }
        else
        {
            let pid = this.project.id;
            console.error(`TimelinePermissions: Failed to unsubscribe from recompute event.  Please report this error to admin@cliovis.com along with the following information: uid: ${this.user.userid}, pid: ${pid}, tid: ${this.folder.id}`);
        }
    }

    async refresh()
    {
        this.project_users.length = 0;
        this.loading_project_users=true;
        console.log('about to load project users');
        try
        {
            console.log('loading');
            let resp = await this.$http.get(`viewprojectusers?pid=${this.project.id}`);
            console.log('loading complete');
            let data = resp.data;
            if (data.error)
            {
                throw {response: resp};
            }
            
            let users = data.users as UserProjectAccess[] | undefined;
            if (!users)
            {
                throw {response: {data: {error: "Failed to read user array"}}};
            }
            
            for(let i = 0; i < data.users.length; ++i)
            {
                let obj = new UserProjectAccess;
                obj = Object.assign(obj, data.users[i]);
                this.project_users.push(obj);
            }
        }
        catch(err)
        {
            console.error(`Failed to load project users: ${err.response.data.error}`);
        }
        this.loading_project_users=false;

        this.loadingAccessList = true;
        try
        {
            const result = await FolderCommands.GetAllPermissions(this.folder.id);
            this.folder.accessList.length = 0;
            for (const access of result)
            {
                const projectUser = this.project_users.find((u) => u.userid == access.User.userid);
                if (!projectUser)
                {
                    console.error(`Failed to find user ${access.User.userid} in project ${this.project.id}`);
                    continue;
                }

                access.User.currentUser = this.user.userid == access.User.userid;
                access.User.display_name = projectUser.display_name;
                access.User.email = projectUser.email;
                access.User.username = projectUser.username;
                this.folder.accessList.push(access);
            }
            this.accessListCounter++;
            console.log({accessList: (this as any).accessList});
        }
        finally
        {
            this.loadingAccessList = false;
        }
    }

    addUser(access : TimelineAccess)
    {
        FolderCommands.SetUserPermission(this.folder.id, access.User.userid, 3);
    }

    removeUser(access : TimelineAccess)
    {
        FolderCommands.SetUserPermission(this.folder.id, access.User.userid, 0);
    }

    changeUserGroup(access : TimelineAccess, value : number)
    {
        FolderCommands.SetUserPermission(this.folder.id, access.User.userid, value);
    }

    shouldDisplayEmail(email : string)
    {
        return !store.state.isLTI;
    }
}
